import axios from '../utils/axios';
import config from '../utils/config';

const BUSINESS_ACCOUNT_LIST = config.get('admin_api', 'business_accounts_list');
const BUSINESS_ACCOUNT_DETAILS = config.get('admin_api', 'business_account_details');
const ONBOARDED_DETAILS = config.get('admin_api', 'onboarded_accounts');
const OTHER_ACCOUNTS_DETAILS = config.get('admin_api', 'other_accounts');
const UPDATE_BM_DETAILS = config.get('admin_api', 'update_bm_details');
const USUAGE_DETAILS = config.get('admin_api', 'usuage_details');
const ADACCOUNT_DETAILS = config.get('admin_api', 'adAccount_details');
const CLIENT_ONBOARD_ACCOUNTS = config.get('admin_api', 'client_onboard_accounts');
const CLIENT_OTHER_ACCOUNTS = config.get('admin_api', 'client_other_accounts');
const BM_USERS = config.get('admin_api', 'bm_users');
const UPDATE_SUPINFO = config.get('admin_api', 'update_supplementary_info');
const ADD_ACCOUNTS = config.get('admin_api', 'add_accounts');
const ADD_NEW_BM = config.get('admin_api', 'add_new_bm');
const DOWNLOAD_USERS = config.get('admin_api', 'download_users');
const DOWNLOAD_TEMPLATE = config.get('admin_api', 'download_ad_acc_template');
export const ADD_ACCONTS_EXCEL = config.get('admin_api', 'add_accounts_excel');

async function businessAccountList(accessToken, username, recordsPerPage, page, searchKeyword, onBoardedOnly, getAll, isSSO) {
  let url = BUSINESS_ACCOUNT_LIST 
  if(getAll){
     url = url+`?getData=ALL`
  }
  else{
     url = BUSINESS_ACCOUNT_LIST + `?recordsPerPage=${recordsPerPage}&page=${page}`;

    if (searchKeyword) {
      url = url + `&searchFields=business_name,business_id&searchText=${searchKeyword}`+`&onboardedOnly=true`;
    }
    if(onBoardedOnly){
      url = url+`&onboardedOnly=true`
    }
  }

  let headers = {}

  if(isSSO){
    headers = {
       'x-access-token': accessToken,
        'x-user': username,
        'x-source': 'sso'
    }
  }else{
 headers = {
       'x-access-token': accessToken,
        'x-user': username,
    }
  }

  try {
    const analysisReqResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers
    });
    return analysisReqResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getBusinessAccountDetails(accessToken, username, accountId) {
  try {
    const accountDetailsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(BUSINESS_ACCOUNT_DETAILS, accountId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return accountDetailsResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getOnboardedAccounts(accessToken, username, accountId, recordsPerPage, page, searchKeyword) {
  let url = config.formUrl(ONBOARDED_DETAILS, accountId) + `?recordsPerPage=${recordsPerPage}&page=${page}`;
  if (searchKeyword) {
    url = url + `&searchFields=account_id,account_name&searchText=${searchKeyword}`;
  }
  try {
    const onboardedDetails = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return onboardedDetails;
  } catch (error) {
    throw error.response;
  }
}

async function getOtherAccounts(accessToken, username, accountId) {
  let url = config.formUrl(OTHER_ACCOUNTS_DETAILS, accountId);
  try {
    const otherDetails = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return otherDetails;
  } catch (error) {
    throw error.response;
  }
}

async function updateBmDetails(accessToken, username, payload, accountId) {
  try {
    const updateBMResponse = await axios({
      method: 'put',
      responseType: 'json',
      url: config.formUrl(UPDATE_BM_DETAILS, accountId),
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateBMResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getUsageDetails(accessToken, username, type, accountId, startDate, endDate) {
  let url = config.formUrl(USUAGE_DETAILS, type, accountId) + `?startDate=${startDate}&endDate=${endDate}`;
  try {
    const usuageResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return usuageResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getAdAccountDetails(accessToken, username, accountId) {
  try {
    const accountDetailsResponse = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(ADACCOUNT_DETAILS, accountId),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return accountDetailsResponse;
  } catch (error) {
    throw error.response;
  }
}

async function getClientOnboardAccounts(accessToken, username, accountId, recordsPerPage, page, searchKeyword) {
  let url = config.formUrl(CLIENT_ONBOARD_ACCOUNTS, accountId) + `?recordsPerPage=${recordsPerPage}&page=${page}`;
  if (searchKeyword) {
    url = url + `&searchFields=account_id,account_name&searchText=${searchKeyword}`;
  }
  try {
    const otherDetails = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return otherDetails;
  } catch (error) {
    throw error.response;
  }
}

async function getClientOtherAccounts(accessToken, username, accountId) {
  let url = config.formUrl(CLIENT_OTHER_ACCOUNTS, accountId);
  try {
    const otherDetails = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return otherDetails;
  } catch (error) {
    throw error.response;
  }
}

async function getBmUsers(accessToken, username, accountId, recordsPerPage, page, searchKeyword) {
  let url = config.formUrl(BM_USERS, accountId) + `?recordsPerPage=${recordsPerPage}&page=${page}`;
  if (searchKeyword) {
    url = url + `&searchFields=email,name&searchText=${searchKeyword}`;
  }
  try {
    const usersRes = await axios({
      method: 'get',
      responseType: 'json',
      url: url,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return usersRes;
  } catch (error) {
    throw error.response;
  }
}

async function updateSupplementaryInfo(accessToken, username, payload, accountId) {
  try {
    const updateResponse = await axios({
      method: 'put',
      responseType: 'json',
      url: config.formUrl(UPDATE_SUPINFO, accountId),
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return updateResponse;
  } catch (error) {
    throw error.response;
  }
}

async function AddAccounts(accessToken, username, payload) {
  try {
    const addResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(ADD_ACCOUNTS),
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return addResponse;
  } catch (error) {
    throw error.response;
  }
}

async function AddNewBM(accessToken, username, payload) {
  try {
    const addResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(ADD_NEW_BM),
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return addResponse;
  } catch (error) {
    throw error.response;
  }
}

async function downloadUsers(accessToken, username, accountId) {
  try {
    const response = await axios({
      method: 'get',
      responseType: 'arraybuffer',
      url: config.formUrl(DOWNLOAD_USERS, accountId),
      headers: {
        'Content-Type': 'blob',
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return response;
  } catch (error) {
    throw error.response;
  }
}

async function downloadTemplate(accessToken, username) {
  try {
    const response = await axios({
      method: 'get',
      responseType: 'json',
      url: config.formUrl(DOWNLOAD_TEMPLATE),
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return response;
  } catch (error) {
    throw error.response;
  }
}

async function addAccountsExcel(accessToken, username, payload) {
  try {
    const addResponse = await axios({
      method: 'post',
      responseType: 'json',
      url: config.formUrl(ADD_ACCONTS_EXCEL),
      data: payload,
      headers: {
        'x-access-token': accessToken,
        'x-user': username,
      },
    });
    return addResponse;
  } catch (error) {
    throw error.response;
  }
}

export {
  businessAccountList,
  getBusinessAccountDetails,
  getOnboardedAccounts,
  getOtherAccounts,
  updateBmDetails,
  getUsageDetails,
  getAdAccountDetails,
  getClientOnboardAccounts,
  getClientOtherAccounts,
  getBmUsers,
  updateSupplementaryInfo, 
  AddAccounts,
  downloadUsers,
  downloadTemplate,
  addAccountsExcel,
  AddNewBM
};